import React, { useState, useRef, useEffect, useCallback } from "react";
import AgeDropdown from "./Dropdown/AgeDropdown.jsx";
import UseDropdown from "./Dropdown/UseDropdown.jsx";
import {
  ax_form_verifyWowNo,
  ax_form_warrantyForm,
} from "../../api/warrantyForm.js";
import { FormInput } from "../FormInput.js";
// import BrandDropdown from "./Dropdown/BrandDropdown.jsx";
import toast from "react-hot-toast";
import { ArrRefreshO } from "lovedicons/dist/arrO";
import pinCodeData from "./PinCode.json";
import imageCompression from "browser-image-compression";
// import axios from "axios";
// import BrandDropdown from "./Dropdown/BrandDropdown.jsx";
// import PurchaseDropdown from "./Dropdown/PurchaseDropdown";

function Form() {
  // const useCaseOptions = [
  //   "BSA",
  //   "BSA Ladybird",
  //   "Hercules Roadeo",
  //   "Hercules",
  //   "Montra",
  //   "Mach City",
  // ];
  // const purchaseOptions = [
  //   "Retail",
  //   "Track & Trail Website",
  //   "Flipkart",
  //   "Amazon",
  // ];

  const initialFormData = {
    // name: "Khaliq",
    // email: "khaliq2@gmail.com",
    // frameNo: "123abc1a",
    // phone: "1234567890",
    // wowNo: "1234abcs1234abcd",
    // pincode: "600014",
    // state: "Tamil Nadu",
    // city: "Chennai",
    // useCase: "Commercial",
    // ageGroup: "18 - 35",
    // brand: "BSA",
    // sourceOfPurchase: "Retail",
    // // purchaseDate: "2025-01-07T14:40:29.818+00:00",
    // purchaseDate: "2025-01-07",
    // dealerName: "Maha Cycles",
    // // file: null,
    // // isTCChecked: true,
    name: "",
    email: "",
    frameNo: "",
    phone: "",
    wowNo: "",
    iDontHaveWowNo: false,
    pincode: "",
    state: "",
    city: "",
    useCase: "",
    ageGroup: "",
    brand: "Hercules",
    productSegment: "",
    sourceOfPurchase: "",
    purchaseDate: "",
    productName: "",
    dealerName: "",
    invoiceFile: null,
    isTCChecked: false,
    createdFromBrand: "hercules",
  };
  // const dummyData = {
  //   name: "Khaliq",
  //   email: "khaliq2@gmail.com",
  //   frameNo: "123abc1a",
  //   phone: "1234567890",
  //   wowNo: "1234abcs1234abcd",
  //   pincode: "600014",
  //   state: "Tamil Nadu",
  //   city: "Chennai",
  //   useCase: "Commercial",
  //   ageGroup: "18 - 35",
  //   brand: "BSA",
  //   sourceOfPurchase: "Retail",
  //   purchaseDate: "2025-01-07",
  //   dealerName: "Maha Cycles",
  //   invoiceFile: [],
  //   isTCChecked: true,
  // };

  // const [formData, setFormData] = useState(initialFormData);
  const [formData, setFormData] = useState(() => ({ ...initialFormData }));
  const [file, setFile] = useState(null);
  const [isWowNoVerified, setIsWowNoVerified] = useState(false);

  const [apiErr, setApiErr] = useState("");

  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // eslint-disable-next-line
  const [errors, setErrors] = useState({});
  const [visiblePopup, setVisiblePopup] = useState(null);

  const [selected, setSelected] = useState("");
  // const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState(""); // Upload Invoice
  const [showDealerField, setShowDealerField] = useState(false); // State to control visibility

  // eslint-disable-next-line
  const [dropdownState, setDropdownState] = useState({
    brandDropdown: false,
    sourceOfPurchase: false,
  });

  const popupRef = useRef(null);
  const fileInputRef = useRef(null);

  const dropdownRefs = {
    brandDropdown: useRef(null),
    sourceOfPurchase: useRef(null),
  };

  const options = ["Retail", "Track & Trail Website", "Flipkart", "Amazon"];

  // const dropdownRef = useRef(null); // Ref for the dropdown container

  // const handleFileChange = (e) => {
  //   // console.log("e.target.files[0].name - ", e.target.files[0].name);
  //   const file = e.target.files[0];

  //   if (!file) {
  //     setErrors((prev) => ({ ...prev, invoiceFile: "File is required" }));
  //     return;
  //   }

  //   const maxSize = 5 * 1024 * 1024; // 5MB in bytes

  //   if (file.size > maxSize) {
  //     toast.error("File size must not exceed 5MB");

  //     // Reset file input to allow re-selection
  //     e.target.value = null;
  //     setErrors((prev) => ({
  //       ...prev,
  //       invoiceFile: "File size must not exceed 5MB",
  //     }));
  //     return;
  //   }

  //   // setFile(e.target.files[0]);
  //   // setFileName(e.target.files[0].name);
  //   setFormData((prev) => ({
  //     ...prev,
  //     invoiceFile: file, // Ensure it's correctly stored in formData
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     invoiceFile: null, // 🔹 Remove "File is required" error
  //   })); // Clear error if valid
  //   setFile(file);
  //   setFileName(file.name);
  //   // toast.success("File uploaded successfully!");
  // };

  const handleFileChange = async (e) => {
    console.log("Original File Name:", e.target.files[0].name);
    const file = e.target.files[0];

    if (!file) {
      setErrors((prev) => ({ ...prev, invoiceFile: "File is required" }));
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    const skipCompressionSize = 800 * 1024; // 800KB in bytes
    const fileType = file.type; // Get file MIME type

    setIsUploading(true); // Start loading

    if (file.size > maxSize) {
      toast.error("File size must not exceed 5MB");

      // Reset file input to allow re-selection
      e.target.value = null;
      setErrors((prev) => ({
        ...prev,
        invoiceFile: "File size must not exceed 5MB",
      }));
      setIsUploading(false); // Stop loading
      return;
    }

    // Skip compression if the file is a PDF or is 800KB or less
    if (fileType === "application/pdf" || file.size <= skipCompressionSize) {
      console.log("Skipping compression for PDF or optimal file size.");

      setFormData((prev) => ({
        ...prev,
        invoiceFile: file,
      }));

      setErrors((prev) => ({
        ...prev,
        invoiceFile: null,
      }));

      setFile(file);
      setFileName(file.name);
      toast.success("File uploaded successfully!");
      setIsUploading(false); // Stop loading
      return;
    }

    try {
      // Compression options
      const options = {
        maxSizeMB: 0.5,
        initialQuality: 0.8,
        useWebWorker: true,
      };

      // Compress the file
      const compressedFile = await imageCompression(file, options);

      console.log("Original File Size:", (file.size / 1024).toFixed(2), "KB");
      console.log(
        "Compressed File Size:",
        (compressedFile.size / 1024).toFixed(2),
        "KB"
      );

      setFormData((prev) => ({
        ...prev,
        invoiceFile: compressedFile,
      }));

      setErrors((prev) => ({
        ...prev,
        invoiceFile: null,
      }));

      setFile(compressedFile);
      setFileName(compressedFile.name);
      toast.success("File compressed & uploaded successfully!");
    } catch (error) {
      console.error("Compression Error:", error);
      toast.error("File compression failed!");
    } finally {
      setIsUploading(false); // Stop loading after processing
    }
  };

  const handleClear = () => {
    setFormData((prevData) => ({
      ...prevData,
      invoiceFile: null, // Remove file from form data
    }));
    setFile(null);
    setFileName(""); // Clear file name
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Upload invoice file clear
  // const handleClear = () => {
  //   // Reset file input value
  //   document.getElementById("invoiceFile").value = "";

  //   // Reset the formData's invoiceFile field
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     invoiceFile: null, // Clear the base64 string or file data
  //   }));

  //   // Clear the fileName state if you're using it
  //   setFileName(null); // Clear the file name if it's being used
  // };

  //base64 conversion
  // const fileToBase64 = (file) => {
  //   // console.log("file", file);

  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = (error) => reject(error);
  //   });
  // };

  // const popupRef = useRef(null);

  const handleSelect = (option) => {
    setFormData((prev) => ({ ...prev, sourceOfPurchase: option }));
    setSelected(option);
    setDropdownState((prev) => ({ ...prev, sourceOfPurchase: false })); // Close the dropdown after selection
    setShowDealerField(option === "Retail"); // Show field if "Retail" is selected
    //clear error for sourceOfPurchase
    // setErrors((prevErrors) => {
    //   const { sourceOfPurchase, ...rest} = prevErrors;
    //   return rest;
    // })
  };

  // Handle Dropdown Visibility
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs).forEach((key) => {
        if (
          dropdownRefs[key].current &&
          !dropdownRefs[key].current.contains(event.target)
        ) {
          // setDropdownState((prev) => ({ ...prev, [`${key}Dropdown`]: false }));
          setDropdownState((prev) => ({ ...prev, sourceOfPurchase: false }));
        }
      });

      if (popupRef.current && !popupRef.current.contains(event.target)) {
        // console.log("Clicked outside popup, closing popup");
        setVisiblePopup(null); // Close popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

  const handleChange = useCallback((fieldName, event) => {
    // console.log("fieldname", fieldName);

    const { type, checked, value } = event.target;

    // setFormData((prevData) => {
    //   const newData = { ...prevData };

    //   switch (type) {
    //     case "file":
    //       if (files?.[0]) {
    //         newData[fieldName] = files[0];
    //         setFileName(files[0].name || value);
    //       }
    //       break;

    //     // case "checkbox":
    //     //   newData[fieldName] = checked;

    //     //   // Special handling for iDontHaveWowNo checkbox
    //     //   if (fieldName === "iDontHaveWowNo") {
    //     //     newData.wowNo = checked ? "" : prevData.wowNo;
    //     //   }
    //     //   break;

    //     default:
    //       newData[fieldName] = value;
    //   }

    //   return newData;
    // });

    setFormData((prevData) => ({
      ...prevData,
      createdFromBrand: prevData.createdFromBrand || "hercules",
      [fieldName]: type === "checkbox" ? checked : value,
    }));
    // setFormData((prevData) => ({
    //   ...prevData,
    //   createdFromBrand: prevData.createdFromBrand || "trackAndTrail",
    //   [fieldName]:
    //     type === "file"
    //       ? files?.[0] || null
    //       : type === "checkbox"
    //       ? checked
    //       : value,
    // }));

    // if (type === "file" && files?.[0]) {
    //   setFileName(files[0].name); // Store file name
    //   const fileType = files[0].type;

    //   if (fileType === "application/pdf") {
    //     // Directly convert PDF to Base64 without compression
    //     fileToBase64(files[0]).then((base64) => {
    //       setFormData((prevData) => ({
    //         ...prevData,
    //         invoiceFile: base64,
    //       }));
    //     });
    //   } else if (fileType.startsWith("image/")) {
    //     const options = {
    //       maxSizeMB: 0.5,
    //       initialQuality: 0.8,
    //       useWebWorker: true, // Improve performance
    //     };

    //     imageCompression(files[0], options)
    //       .then((compressedFile) => {
    //         return fileToBase64(compressedFile);
    //       })
    //       .then((base64) => {
    //         console.log("Compressed Base64:", base64);

    //         setFormData((prevData) => ({
    //           ...prevData,
    //           invoiceFile: base64, // Store Base64 separately
    //         }));
    //       })
    //       .catch((error) => {
    //         console.error("Compression failed:", error);
    //       });
    //   }
    // }
  }, []);

  const validateField = (name, value) => {
    const validators = {
      // name: (value) => (value.trim() ? null : "Name is required"),
      name: (value) =>
        !value.trim()
          ? "Name is required"
          : value.trim().length < 3
          ? "must be at least 3 characters"
          : value.trim().length > 50
          ? "must not exceed 50 characters"
          : null,
      email: (value) =>
        /^[\w.-]+@[\w-]+\.[\w-]{2,4}$/.test(value)
          ? null
          : "Invalid email address",
      phone: (value) =>
        /^\d{10}$/.test(value) ? null : "Phone must be 10 digits",
      pincode: (value) => (/^\d{6}$/.test(value) ? null : "must be 6 digits"),
      state: (value) => (value.trim() ? null : "State is required"),
      city: (value) => (value.trim() ? null : "City is required"),
      frameNo: (value) =>
        /^[a-zA-Z0-9]{7,12}$/.test(value)
          ? null
          : "Frame No must be 7-12 characters",
      wowNo: (value) =>
        !value || /^[a-zA-Z0-9]{16}$/.test(value)
          ? undefined
          : "Wow No should be 16 characters",
      // wowNo: (value) =>
      //   value.trim() && /^[a-zA-Z0-9]{16}$/.test(value)
      //     ? null
      //     : "Wow No should be 16 characters",
      // wowNo: (value) => {
      //   if (formData.notWowNo) {
      //     return null; // Skip validation if the checkbox is checked
      //   }
      //   return value.trim() && /^[a-zA-Z0-9]{16}$/.test(value)
      //     ? null
      //     : "Wow No should be 16 characters";
      // },
      // brand: (value) => (value.trim() ? null : "Brand is required"),
      sourceOfPurchase: (value) =>
        value.trim() ? null : "Source of Purchase is required",
      purchaseDate: (value) =>
        new Date(value) <= new Date()
          ? null
          : "Invalid or future Purchase Date",
      // productName: (value) =>
      //   value.trim() ? null : "Product Name is required",
      productName: (value) =>
        !value.trim()
          ? "Product Name is required"
          : value.trim().length < 3
          ? "must be at least 3 characters"
          : value.trim().length > 100
          ? "must not exceed 100 characters"
          : null,
      // dealerName: (value) => {
      //   if (formData.sourceOfPurchase === "Retail") {
      //     return value.trim() ? null : "Dealer Name is required";
      //   }
      //   return null; // Not required for other purchase sources
      // },
      dealerName: (value) =>
        formData.sourceOfPurchase === "Retail"
          ? !value.trim()
            ? "Dealer Name is required"
            : value.trim().length < 3
            ? "Must be at least 3 characters"
            : value.trim().length > 50
            ? "Must not exceed 50 characters"
            : null
          : null, // Not required for other purchase sources
      // invoiceFile: (value) => {
      //   // console.log("value.type - " + value);
      //   if (!value) return "File is required"; // Handle no file selected case
      //   if (
      //     value.type &&
      //     ["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
      //       value.type
      //     )
      //   ) {
      //     return null; // Valid file type
      //   }
      // },
      invoiceFile: (file) => {
        if (!file) return "File is required"; // Ensure file is selected

        const allowedTypes = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(file.type)) {
          return "Invalid file type. Allowed: PNG, JPG, JPEG, PDF";
        }

        if (file.size > maxSize) {
          return "File size must not exceed 5MB";
        }

        return null; // No error, file is valid
      },
      isTCChecked: (value) =>
        value ? null : "You must agree to the Terms and Conditions",
    };

    return validators[name] ? validators[name](value) : null;
  };

  const validateForm = () => {
    const newErrors = Object.keys(formData).reduce((acc, field) => {
      const error = validateField(field, formData[field]);
      if (error) acc[field] = error;
      return acc;
    }, {});

    return newErrors;
  };

  // const onVerifyClick = async () => {
  //   const ax_resVerify = await ax_form_verifyWowNo(formData?.wowNo);
  //   console.log("ax_resVerify - " + JSON.stringify(ax_resVerify));
  // };

  const onVerifyClick = async () => {
    const ax_resVerify = await ax_form_verifyWowNo(formData?.wowNo);
    // console.log("ax_resVerify - " + JSON.stringify(ax_resVerify));

    if (ax_resVerify && ax_resVerify.length > 0) {
      // console.log(
      //   "ax_resVerify[0].TagSerialNo.includes(formData?.wowNo) -> ",
      //   ax_resVerify[0].TagSerialNo.includes(formData?.wowNo)
      // );
      if (
        ax_resVerify[0].TagSerialNo === formData?.wowNo ||
        ax_resVerify[0].TagSerialNo.includes(formData?.wowNo)
      ) {
        setIsWowNoVerified(true);
        toast.success("WowNo. verified!");
      } else {
        setIsWowNoVerified(false);
        toast.error("Oops! WowNo. not found!");
      }
    } else {
      setIsWowNoVerified(false);
      toast.error("Oops! WowNo. not found!");
    }
  };

  // Auto-fill state and city based on pincode
  useEffect(() => {
    // Only update if pincode has a value
    if (formData.pincode) {
      const matchingLocation = pinCodeData.find(
        (location) => location.pincode === formData.pincode
      );

      if (matchingLocation) {
        setFormData((prevData) => ({
          ...prevData,
          state: matchingLocation.state,
          city: matchingLocation.city,
        }));
      }
      // else {
      //   // Clear state and city if pincode is not found
      //   setFormData((prevData) => ({
      //     ...prevData,
      //     state: "",
      //     city: "",
      //   }));
      // }
    }
    // else {
    //   // Clear state and city if pincode is empty
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     state: "",
    //     city: "",
    //   }));
    // }
  }, [formData.pincode]);
  // const formDataToSend = new FormData();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const validationErrors = validateForm();
    // console.log("validationErrors - ", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsLoading(false);
      return;
    } else {
      setErrors({});
    }

    console.log("All errors cleared!", { validationErrors, errors });

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("invoiceFile", file);
      // console.log("After appending file: ", formDataToSend.get("invoiceFile"));

      formDataToSend.append("name", formData?.name);
      formDataToSend.append("email", formData?.email);
      formDataToSend.append("frameNo", formData?.frameNo);
      formDataToSend.append("phone", formData?.phone);
      formDataToSend.append("wowNo", formData?.wowNo);
      // formDataToSend.append("wowNo", formData?.wowNo ? formData.wowNo : "Not provided");
      formDataToSend.append("pincode", formData?.pincode);
      formDataToSend.append("state", formData?.state);
      formDataToSend.append("city", formData?.city);
      formDataToSend.append(
        "useCase",
        formData?.useCase ? formData.useCase : "Not provided"
      );
      formDataToSend.append(
        "ageGroup",
        formData?.ageGroup ? formData.ageGroup : "Not provided"
      );
      formDataToSend.append("brand", formData?.brand);
      formDataToSend.append("sourceOfPurchase", formData?.sourceOfPurchase);
      formDataToSend.append("purchaseDate", formData?.purchaseDate);
      formDataToSend.append("productName", formData?.productName);
      if (showDealerField) {
        formDataToSend.append("dealerName", formData?.dealerName);
      }
      formDataToSend.append("isTCChecked", formData?.isTCChecked);
      formDataToSend.append("isWowNoVerified", isWowNoVerified);
      formDataToSend.append("createdFromBrand", formData?.createdFromBrand);

      // const payload = {
      //   name,
      //   email,
      //   frameNo,
      //   phone,
      //   wowNo,
      //   // iDontHaveWowNo,
      //   pincode,
      //   state,
      //   city,
      //   useCase,
      //   ageGroup,
      //   brand,
      //   sourceOfPurchase,
      //   purchaseDate,
      //   productName,
      //   dealerName,
      //   isTCChecked,
      //   createdFromBrand,
      //   invoiceFile: file,
      // };
      // for (let pair of formDataToSend.entries()) {
      //   console.log(pair[0] + ": " + pair[1]);
      // }

      // const response = await axios.post(
      //   "http://localhost:5000/upload",
      //   formData,
      //   {
      //     headers: { "Content-Type": "multipart/form-data" },
      //   }
      // );
      // console.log("inside file - ", file);
      // console.log("typeof - ", typeof formDataToSend);
      // console.log("?.invoiceFile - ", formDataToSend?.invoiceFile);

      // const { data } = await axios.get(
      //   "http://your-backend-ec2-ip:5000/generate-presigned-url",
      //   {
      //     params: { fileName: file.name, fileType: file.type },
      //   }
      // );

      // // Step 2: Upload file to S3 using the pre-signed URL
      // await axios.put(data.url, file, { headers: { "Content-Type": file.type } });

      // alert("File uploaded successfully!");
      // console.log("Sending form data to backend:", formDataToSend);
      const response = await ax_form_warrantyForm(formDataToSend);
      // console.log("Received response from backend:", response);
      // console.log("payload - " + JSON.stringify(payload));
      // console.log("response - " + JSON.stringify(response));
      if (response?.success) {
        //    // Send an email after successful form submission
        //    await axios.post("http://localhost:5001/send-email", payload, {
        //     headers: { "Content-Type": "application/json" },
        // });

        toast.success("Form Submitted Successfully");
        setApiErr("");
        setFormData(initialFormData);
        setSelected("");
        setFileName(null);
        setShowDealerField(false);
        setIsWowNoVerified(false);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.error(response?.data.description || "Submission Failed");
        setApiErr(response?.data.description || "Unknown error occurred");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error("An unexpected error occurred. Please try again later.");
      setIsLoading(false);
    }
  };

  // console.log("files - " + JSON.stringify(formData?.invoiceFile[].type));
  // console.log("FormData.invoiceFile " + JSON.stringify(formData?.invoiceFile));
  // console.log("formData", formData);

  // console.log("file", file);
  // console.log("formDataToSend - " + JSON.stringify(formDataToSend));
  // console.log("fileName", fileName);
  // console.log("FormData",formData);

  return (
    <section className="mt-6 px-4 bg-form-bg min-h-screen flex justify-center items-start">
      <div className="p-12 mt-10 max-w-6xl w-full bg-[#0e0e0e] rounded-lg">
        {/* Warranty Header */}
        <div className="mb-6 xl:absolute xl:left-1 xl:top-52">
          <h1
            className="text-4xl text-white font-black xl:-rotate-90"
            style={{ fontFamily: "var(--title-font)" }}
          >
            Warranty
          </h1>
        </div>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-6 text-white"
        >
          <section className="lg:m-auto xl:w-full lg:flex gap-6">
            {/* User details Fields */}
            <div className="space-y-5 w-full">
              {/* Name */}
              <FormInput
                label={"Name"}
                name={"name"}
                type={"text"}
                placeholder={"Enter your name"}
                value={formData?.name}
                onChange={(e) => handleChange("name", e)}
                error={errors.name}
              />

              <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Email */}
                <FormInput
                  label={"Email"}
                  name={"email"}
                  type={"text"}
                  placeholder={"Enter your email"}
                  value={formData?.email}
                  onChange={(e) => handleChange("email", e)}
                  error={errors.email}
                />

                {/* Phone */}
                <FormInput
                  label={"Whatsapp Number"}
                  name={"phone"}
                  type={"text"}
                  placeholder={"Enter your whatsapp No"}
                  value={formData?.phone}
                  // onChange={(e) => handleChange("phone", e)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      handleChange("phone", {
                        target: { name: "phone", value },
                      });
                    }
                  }}
                  error={errors.phone}
                />
              </div>

              {/* <div className="flex flex-col sm:flex-row gap-4 space-y-4 sm:items-end"> */}
              <div className="my-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                <FormInput
                  label={"Pincode"}
                  name={"pincode"}
                  type={"text"}
                  placeholder={"pincode"}
                  value={formData?.pincode}
                  // onChange={(e) => handleChange("pincode", e)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) {
                      handleChange("pincode", {
                        target: { name: "pincode", value },
                      });
                    }
                  }}
                  error={errors.pincode}
                />

                <FormInput
                  label={"State"}
                  name={"state"}
                  type={"text"}
                  placeholder={"state"}
                  value={formData?.state}
                  isReadOnly={true}
                  onChange={(e) => handleChange("state", e)}
                  error={errors.state}
                />
                <FormInput
                  label={"City"}
                  name={"city"}
                  type={"text"}
                  placeholder={"city"}
                  value={formData?.city}
                  isReadOnly={!formData?.pincode}
                  onChange={(e) => handleChange("city", e)}
                  error={errors.city}
                />
              </div>

              <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <UseDropdown
                  selectedUseCase={formData?.useCase}
                  formData={formData}
                  setFormData={setFormData}
                  // error={errors?.useCase}
                />

                <AgeDropdown
                  selectedAge={formData?.ageGroup}
                  formData={formData}
                  setFormData={setFormData}
                  // error={errors?.ageGroup}
                />
              </div>
            </div>

            {/* Cycle details Fields */}
            {/* Frame No */}
            <div className="mt-4 md:mt-0 space-y-5 w-full">
              <div className="w-full">
                <FormInput
                  label={"Frame No"}
                  name={"frameNo"}
                  type={"text"}
                  placeholder={"Frame No"}
                  value={formData?.frameNo}
                  onChange={(e) => handleChange("frameNo", e)}
                  error={errors.frameNo}
                  showIcon={true}
                  togglePopup={() => setVisiblePopup("frame")}
                />
              </div>
              {/* Tax S.No */}
              <FormInput
                label="Wow No"
                name="wowNo"
                type="text"
                placeholder="Wow No"
                value={formData.wowNo}
                onChange={(e) => handleChange("wowNo", e)}
                error={errors.wowNo}
                showIcon={true}
                togglePopup={() => setVisiblePopup("wow")}
                // showCheckbox={true}
                // checkboxLabel="I don’t have Wow No"
                // checkboxName="notWowNo"
                // checkboxChecked={formData.notWowNo}
                // onCheckboxChange={(e) => handleChange("notWowNo", e)}
                showButtons={true}
                onVerifyClick={onVerifyClick}
                verifyButtonValue={isWowNoVerified ? "Verified" : "Verify"}
                onResetClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    wowNo: "",
                  }));
                  setIsWowNoVerified(false);
                }}
                // isReadOnly={formData.iDontHaveWowNo}
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="relative" ref={dropdownRefs.sourceOfPurchase}>
                  {/* Label */}
                  <label
                    htmlFor="sourceOfPurchase"
                    className="block text-sm font-medium flex justify-between"
                  >
                    Source Of Purchase
                    <span className="text-red-500">*</span>
                  </label>

                  {/* Dropdown Button */}
                  <div
                    className="flex justify-between items-center px-4 py-2 h-12 bg-[#f1f1f1]  cursor-pointer"
                    onClick={() =>
                      setDropdownState((prev) => ({
                        ...prev,
                        sourceOfPurchase: !prev.sourceOfPurchase,
                      }))
                    }
                    id="sourceOfPurchase"
                    name="sourceOfPurchase"
                  >
                    <span className="text-sm text-gray-600">
                      {formData.sourceOfPurchase || "Select Source of Purchase"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-5 w-5 transform transition-transform ${
                        dropdownState.sourceOfPurchase
                          ? "rotate-180"
                          : "rotate-0"
                      }`}
                      viewBox="0 0 20 20"
                      fill="text-gray-600"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>

                  {/* Dropdown Options */}
                  {dropdownState.sourceOfPurchase && (
                    <div className="absolute w-full bg-white mt-1  shadow-lg z-10">
                      {options.map((option, index) => (
                        <div
                          key={index}
                          className={`px-4 py-2 text-md cursor-pointer ${
                            selected === option
                              ? "bg-gray-200 text-black border-l-4 border-[#ec1c24]" // Highlight selected option
                              : "hover:bg-gray-200 text-black" // Default styling for unselected options
                          }`}
                          onClick={() => handleSelect(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                  {errors.sourceOfPurchase && (
                    <p className="text-red-500 text-sm">
                      {errors.sourceOfPurchase}
                    </p>
                  )}
                </div>

                {/* Purchase Date */}
                <FormInput
                  label={"Purchase Date"}
                  name={"purchaseDate"}
                  type={"date"}
                  placeholder={"purchaseDate"}
                  value={formData?.purchaseDate}
                  onChange={(e) => handleChange("purchaseDate", e)}
                  error={errors.purchaseDate}
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="mt-1">
                  <FormInput
                    label={"Product Name"}
                    name={"productName"}
                    type={"text"}
                    placeholder={"Product Name"}
                    value={formData?.productName}
                    onChange={(e) => handleChange("productName", e)}
                    error={errors.productName}
                  />
                </div>

                {/* Dealer Name  */}
                {showDealerField && (
                  <FormInput
                    label={"Dealer Name"}
                    name={"dealerName"}
                    type={"text"}
                    placeholder={"dealerName"}
                    value={formData?.dealerName}
                    onChange={(e) => handleChange("dealerName", e)}
                    error={errors.dealerName}
                  />
                )}
              </div>
            </div>
          </section>

          <div>
            {/* Upload Invoice */}
            <label
              htmlFor="invoiceFile"
              className="mt-2 flex max h-[68px] justify-center items-center font-semibold cursor-pointer border-dashed border-2 border-[#fffff]-600 "
            >
              {isUploading ? (
                <ArrRefreshO className="w-6 h-6 animate-spin" />
              ) : fileName || formData?.invoiceFile?.name ? (
                `Uploaded file: ${fileName || formData?.invoiceFile.name}`
              ) : (
                <div>
                  UPLOAD INVOICE FILE
                  <span className="text-red-500">*</span>
                </div>
              )}

              {/* {fileName || formData?.invoiceFile
                ? `Uploaded file: ${fileName || formData?.invoiceFile}`
                : "UPLOAD INVOICE FILE"} */}
            </label>
            <input
              ref={fileInputRef}
              id="invoiceFile"
              name="invoiceFile"
              type="file"
              accept=".pdf, .png, .jpg, .jpeg"
              className="hidden"
              onChange={handleFileChange}
              // onChange={(e) => handleChange("invoiceFile", e)}
            />
            <div className="mt-1 flex flex-row justify-between items-center">
              <p className="text-xs text-gray-400 mt-1">
                Allowed formats: PDF, PNG, JPG, JPEG (Max: 5MB)
              </p>
              {(fileName || formData.invoiceFile) && (
                <div
                  onClick={handleClear}
                  className="text-sm cursor-pointer text-blue-500 text-end"
                >
                  Clear
                </div>
              )}
            </div>
          </div>
          {errors.invoiceFile && (
            <span className="text-red-500 text-sm">{errors.invoiceFile}</span>
          )}

          {/* Terms and Conditions */}
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="isTCChecked"
              name="isTCChecked"
              value={FormData?.isTCChecked}
              onChange={(e) => handleChange("isTCChecked", e)}
              checked={formData?.isTCChecked}
              className="h-4 w-4 text-red-400 border-gray-300 rounded focus:ring-red-400"
            />
            <label htmlFor="isTCChecked" className="text-sm font-medium">
              I agree to the{" "}
              <a
                href="/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                Terms and Conditions
              </a>
            </label>
          </div>
          {errors.isTCChecked && (
            <span className="text-red-500 text-sm">{errors.isTCChecked}</span>
          )}

          {/* Submit Button */}
          <div className="flex flex-col items-center">
            <div className="text-red-500 text-sm">{apiErr}</div>
            <button
              disabled={isLoading && formData?.isTCChecked}
              type="submit"
              className="w-full mt-10 md:mt-5 px-6 py-3 bg-[#ec1c24] text-white font-semibold "
              style={{ width: "200px" }}
            >
              {isLoading ? (
                <ArrRefreshO className="w-full h-6 animate-spin" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
          {visiblePopup && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
              ref={popupRef}
            >
              <div className="bg-white max-w-xl p-5 shadow-md">
                <h2 className="text-md font-medium text-black mb-3">
                  {visiblePopup === "frame"
                    ? "Finding Your Bicycle's Frame Number"
                    : "Finding Your Bicycle's WoW Number"}
                </h2>
                <p className="text-black text-sm">
                  {visiblePopup === "frame" ? (
                    <>
                      The Frame Number of your bicycle is a unique identifier,
                      typically formatted like{" "}
                      <span className="font-medium">"IFPxxx01"</span>. You can
                      find this number engraved on the bicycle frame.
                    </>
                  ) : (
                    "The WoW Number of your bicycle is a unique identifier consisting of characters, typically printed on a sticker located on the bicycle frame. Enter the 16 characters."
                  )}
                </p>

                <button
                  className="mt-4 px-4 py-2 bg-[#ec1c24] text-white"
                  onClick={() => setVisiblePopup(null)}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    </section>
  );
}

export default Form;
